import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { useSupplier } from "../../../../../hooks/query";

export default function useCreateSupplier() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { useCreate } = useSupplier();
    const createSupplierSvc = useCreate();

    const handleCreateSupplier = async (values: any) => {
        try {
            const supplierParams = {
                Name: values.Name,
                Description: values.Description,
                Email: values.Email || undefined,
                PhoneNumber: values.PhoneNumber || undefined,
                Address: values.Address || undefined,
                City: values.City || undefined,
                Country: values.Country || undefined,
                Website: values.Website || undefined,
                Status: "Active", // Hardcoded as Active
                LogoUrl: values.LogoUrl || undefined,
                Type: "distributor", // Hardcoded as distributor
            };

            await createSupplierSvc.mutateAsync(supplierParams);

            queryClient.invalidateQueries({ queryKey: ["suppliers"] });

            // Navigate back to suppliers list
            navigate("/suppliers/list");
        } catch (error) {
            console.error("Error creating supplier:", error);
            throw error;
        }
    };

    return {
        handleCreateSupplier,
        createSupplierSvc,
    };
}
